module.exports = __webpack_public_path__ + "img/66.2.TN.3d0038d0.png";